module.exports = __webpack_public_path__ + "media/images/icons/icon_calender_grey-78dbb78a66abedc33df8a356df779086.svg";